document.addEventListener('click', function(e) {
  if (e.target.matches('.cross-sell-add-btn')) {
    e.preventDefault();
    var form = e.target.closest('form');
    document.dispatchEvent(
      new CustomEvent('theme:cart:add', {
        detail: { button: e.target, form: form }
      })
    );
  }
});

// Listen for cart updates and refresh cross-sell
document.addEventListener('theme:product:added', function() {
  fetch('/cart?section_id=api-cart-items')
    .then(function(res) { return res.text(); })
    .then(function(html) {
      var tempDiv = document.createElement('div');
      tempDiv.innerHTML = html;
      var newCrossSell = tempDiv.querySelector('[data-api-content-cross-sell]');
      var container = document.getElementById('cart-cross-sell-container');
      if (container) {
        if (newCrossSell) {
          container.innerHTML = '';
          container.appendChild(newCrossSell.firstElementChild);
          //Trigger the experience
          window._conv_q = window._conv_q || [];
          window._conv_q.push({
            what: "triggerLocation",
            params: {
              locationId: "1004123343"
            }
          });
        } else {
          container.innerHTML = '';
        }
      }
    });
});

document.addEventListener('theme:cart-drawer:open', function() {
  fetch('/cart?section_id=api-cart-items')
    .then(function(res) { return res.text(); })
    .then(function(html) {
      var tempDiv = document.createElement('div');
      tempDiv.innerHTML = html;
      var newCrossSell = tempDiv.querySelector('[data-api-content-cross-sell]');
      var container = document.getElementById('cart-cross-sell-container');
      if (container) {
        if (newCrossSell) {
          container.innerHTML = '';
          container.appendChild(newCrossSell.firstElementChild);
          //Trigger the experience
          window._conv_q = window._conv_q || [];
          window._conv_q.push({
            what: "triggerLocation",
            params: {
              locationId: "1004123343"
            }
          });
        } else {
          container.innerHTML = '';
        }
      }
    });
});